import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useRouter from '../../utils/useRouter';
import MasterLayout from '../../components/AppLayout/MasterLayout';
import { routes } from '../../constants';
import useAction from '../../utils/useAction';
import { loginKeycloakUser } from '../../actions/auth.actions';
import { selectIsAuthenticated } from '../../reducers/user.selectors';
import { useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import ApiError from '@klab-berlin/api-sdk/lib/utils/ApiError';

const KeycloakSSORedirect: React.FC = () => {
  const { t } = useTranslation();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const [isFetchingAuth, setIsFetchingAuth] = useState(true);
  const [error, setError] = useState<string | undefined>(undefined);
  const [isBildungsserverError, setIsBildungsserverError] = useState(false);
  const loginKeycloakUserAction = useAction(loginKeycloakUser);
  const { router, match: { location: { query: { code } } } } = useRouter();

  if (!code) {
    router.push(`/${routes.notFound.root}`);
  }

  useEffect(() => {
    setIsBildungsserverError(false);
    loginKeycloakUserAction(code)
      .then(() => setIsFetchingAuth(false))
      .catch((error: ApiError) => {
        if (error.statusCode === 403) {
          setError(t('Bildungsserver registration disabled'));
          setIsBildungsserverError(true);
        } else if (error.message.match(/Email address already exists/)) {
          setError(t('This Email address already exists'));
        } else {
          router.push(`/${routes.notFound.root}`);
        }
      });
    setTimeout(() => setIsFetchingAuth(false), 3300);
  }, [code]);

  useEffect(() => {
    if (!isFetchingAuth && isAuthenticated) {
      router.push(`/${routes.dashboard.root}`);
    }
  }, [isFetchingAuth, isAuthenticated]);

  return (
    <MasterLayout>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
      }}>
        {!isBildungsserverError && (
          <Box sx={{
            fontFamily: 'Roboto',
            fontSize: '32px',
            fontWeight: 700,
            lineHeight: '37.5px',
            color: '#44555d'
          }}>{t('Please wait a moment')}</Box>
        )}
        {
          error
            ? <Typography sx={{
              fontFamily: 'Roboto',
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '18.75px',
              color: 'error.main',
            }}>
              {isBildungsserverError
                ? error
                : `${error}. ${t('Please contact our support-team.')}`}
            </Typography>
            : <Typography sx={{
              fontFamily: 'Roboto',
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '18.75px',
              color: '#44555d'
            }}>
              {t('We are connecting meinUnterricht with the login provider.')}
            </Typography>
        }
      </Box>
    </MasterLayout>
  );
};

export default KeycloakSSORedirect;
